import { Lightning, Router, Storage } from "@lightningjs/sdk";
import theme from "../../../lib/theme";
import { CategoryModel } from "../../../lib/models";
import { MENU_WIDTH } from "../../../lib/utils";
import { MediaList } from "../MediaList/MediaList";
import configs from "../../../lib/configs";
import { MediaFilters } from "../MediaFilters/MediaFilters";

interface VodTemplateSpec extends Lightning.Component.TemplateSpec {
    Page: {
        Filters: typeof MediaFilters;
        List: typeof MediaList;
    };
}

interface VodTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export class MediaCategoryName
    extends Lightning.Component<VodTemplateSpec, VodTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<VodTemplateSpec>
{
    _showFilterCategories = true;
    _filters: any;
    _categoryId?: number | string;

    // static _offsetX = configs.layout.content.alignWithBanner ? theme.banner.padding.x : theme.layout.content.x;
    static override _template(): Lightning.Component.Template<VodTemplateSpec> {
        return {
            collision: true,
            Page: {
                collision: true,
                h: theme.layout.h - theme.banner.padding.y * 2,
                w: theme.layout.w - MENU_WIDTH,
                x: MENU_WIDTH,
                y: theme.banner.padding.y,
                Filters: {
                    type: MediaFilters,
                    x: theme.layout.content.x,
                    signals: {
                        toggleFilters: "_toggleFilters",
                        search: "_search"
                    }
                },
                List: {
                    type: MediaList,
                    h: theme.layout.h,
                    w: (w) => w - theme.layout.content.x,
                    collision: true,
                    isFullScreen: true
                }
            }
        };
    }

    readonly Page = this.getByRef("Page")!;
    readonly List = this.Page.getByRef("List")!;
    readonly Filters = this.Page.getByRef("Filters")!;

    override _active() {
        // console.log("MC is active", this._showFilterCategories, this._filters);
        // this.patch({
        //     x: MENU_WIDTH
        // });
    }

    override _setup() {
        // console.log("MC is _setup");
        const filters = Storage.get("filters");
        if (configs?.layout?.filters?.enabled && Object.keys(filters)?.length) {
            this.List.patch({
                y: 50,
                showCategoryName: false
            });
        }
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return this.List;
    }

    override _handleUp(): void {
        if (configs?.layout?.filters?.enabled) {
            const filters = Storage.get("filters");
            if (!Object.keys(filters)?.length) return;

            this._setState("FiltersState");
        }
    }

    _toggleFilters(isOpen: boolean, skipHistory: boolean = false) {
        if (!skipHistory) {
            if (isOpen) {
                const url = new URL(String(window.location.href));
                url.searchParams.set("filters", "true");
                // Preserve previous state when opening filters
                const previousState = history.state || {};
                history.pushState({ filters: true, previousState }, "", url);
            } else {
                // When closing filters, push a new state with filters: false and preserve previous state
                const url = new URL(String(window.location.href));
                url.searchParams.delete("filters");
                const previousState = history.state?.previousState || history.state || {};
                history.pushState({ filters: false, previousState }, "", url);
            }
        }

        // Update List position
        this.List.patch({
            smooth: {
                x: isOpen ? 296 : theme.layout.content.x
            }
        });

        // Update filters component and page state
        if (isOpen) {
            // Open filters: set filters component to FilterState and page to FiltersState
            if (this.Filters && typeof (this.Filters as any)._setState === "function") {
                (this.Filters as any)._setState("FilterState");
            }
            this._setState("FiltersState");
        } else {
            // Close filters: use _closeWithoutSignal to avoid retriggering _toggleFilters
            if (this.Filters && typeof (this.Filters as any)._closeWithoutSignal === "function") {
                (this.Filters as any)._closeWithoutSignal();
            }

            // Reset page state (safe to call even if not in FiltersState)
            this._setState("");
        }
    }

    async _search(filters: { genres: string[]; languages: string[]; countries: string[] }) {
        this._filters = filters;

        this.List.patch({
            filters
        });
        this.List._reloadItems();
    }

    static override _states() {
        return [
            class FiltersState extends this {
                override _getFocused() {
                    return this.Filters;
                }

                override _handleDown(): void {
                    this._setState("");
                }
            }
        ];
    }

    set data(value: CategoryModel) {
        this._categoryId = value.id ? value.id! : undefined;
        this.List.patch({
            categoryId: value.id ? value.id! : undefined,
            categoryKey: value.name,
            isFullScreen: true,
            items: value.items
        });
    }

    set showFilterCategories(value: boolean) {
        // console.log("MC showFilterCategories");

        this._showFilterCategories = value;
        this.Filters.patch({
            showFilterCategories: value,
            selectedCategory: this._categoryId
        });
    }
}
